class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
        
      }
    });
  }

  open(triggeredBy) {

      if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });


      setTimeout(()=>{
    document.querySelector("#age-certification").addEventListener("change", function(e){
if (e.target.checked ==true && document.querySelector("#agree-terms").checked == true) {

    let a = document.getElementById("CartDrawer-Gift-RName")
    let b = document.getElementById("CartDrawer-Gift-REmail")
    let c = document.getElementById("CartDrawer-Gift-RPhone")


    if (document.querySelector("#giftq").checked && (a.value == "" || b.value == "" || c.value == ""))
    {
        document.querySelector("#CartDrawer-Checkout").style.pointerEvents  = "none"
   document.querySelector("#CartDrawer-Checkout").style.opacity  = "0.4"
    }else {
        document.querySelector("#CartDrawer-Checkout").style.pointerEvents  = "auto"
   document.querySelector("#CartDrawer-Checkout").style.opacity  = "1"
    }
       
}else {
 
         document.querySelector("#CartDrawer-Checkout").style.pointerEvents  = "none"
   document.querySelector("#CartDrawer-Checkout").style.opacity  = "0.4"
  
}
})
        
  },2000)
         setTimeout(()=>{
    document.querySelector("#agree-terms").addEventListener("change", function(e){
if (e.target.checked ==true && document.querySelector("#agree-terms").checked == true) {
   let a = document.getElementById("CartDrawer-Gift-RName")
    let b = document.getElementById("CartDrawer-Gift-REmail")
    let c = document.getElementById("CartDrawer-Gift-RPhone")


    if (document.querySelector("#giftq").checked && (a.value == "" || b.value == "" || c.value == ""))
    {
        document.querySelector("#CartDrawer-Checkout").style.pointerEvents  = "none"
   document.querySelector("#CartDrawer-Checkout").style.opacity  = "0.4"
    }else {
        document.querySelector("#CartDrawer-Checkout").style.pointerEvents  = "auto"
   document.querySelector("#CartDrawer-Checkout").style.opacity  = "1"
    }
}else {
   document.querySelector("#CartDrawer-Checkout").style.pointerEvents  = "none"
   document.querySelector("#CartDrawer-Checkout").style.opacity  = "0.4"
}
})
        
  },2000)
    this.addEventListener(
      'transitionend',
      () => {
       
  
      this.UpdateCustomShip()
        setTimeout(()=>{
     if (document.querySelector("#agree-terms").checked == false || document.querySelector("#age-certification").checked == false) {
          document.querySelector("#CartDrawer-Checkout").style.pointerEvents  = "none"
        document.querySelector("#CartDrawer-Checkout").style.opacity  = "0.4"
     }
    
    },3500)

        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }
UpdateCustomShip() {

try {
         var current_sel = document.querySelector(".bcdp-method-active").querySelector(".bcdp-method-wrap-txt").innerHTML 
          document.querySelectorAll(".bcdp-method-wrap-txt").forEach(f=>{
            if (f.innerHTML == "Shipping") {
              f.click()
            }else {
          let address1= readAddressCookie()
          if (current_sel != "Local Delivery") {
             document.querySelector("#Details-CartDrawer").style.display="none";
          }else {
            document.querySelector(".bcdp-icon-wrap").click()
  
                document.querySelector("input.bcdp-widget-input").value = address1.zip
      
           
          }
            }
          })

          
   document.querySelectorAll(".bcdp-method-wrap").forEach((f)=>{
  f.addEventListener("click",function(){
      if (f.querySelector(".bcdp-method-wrap-txt").innerHTML == "Local Delivery") {
     setTimeout(()=>{
        let address1= readAddressCookie()
             setTimeout(()=>{
                document.querySelector("input.bcdp-widget-input").value = address1.zip
                       document.querySelector("input.bcdp-widget-input").dispatchEvent(new Event("input"))
            },500)
      


       
     },500)
        
 
      }
  })
})
}catch(e){
  
}
       
         
}
  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
  
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
        if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);


      
    });
setTimeout(()=>{
  setupGiftInputValidation()
},1500)
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));

      this.open();
      setTimeout(()=>{
         this.UpdateCustomShip()
      },2000)
      

   
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
